import { render } from "./add-education-modal.vue?vue&type=template&id=78042a74&ts=true"
import script from "./add-education-modal.vue?vue&type=script&lang=ts"
export * from "./add-education-modal.vue?vue&type=script&lang=ts"

import "./add-education-modal.vue?vue&type=style&index=0&id=78042a74&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__